import { countries } from '../../../ApplicationFormPage/Residency/countries';

export enum ResidencyStatus {
  BRITISH_CITIZEN = 'BRITISH_CITIZEN',
  EU_SETTLED_OR_PRE_SETTLED = 'EU_SETTLED_OR_PRE_SETTLED',
  INDEFINITE_LEAVE_TO_REMAIN = 'INDEFINITE_LEAVE_TO_REMAIN',
  SPOUSAL_VISA = 'SPOUSAL_VISA',
  OTHER = 'OTHER',
}

export enum TaxpayerType {
  UK_BASIC_RATE = 'UK_BASIC_RATE',
  COMPANY = 'COMPANY',
  UK_HIGHER_RATE = 'UK_HIGHER_RATE',
  NON_UK_TAXPAYER = 'NON_UK_TAXPAYER',
}

export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  CIVIL_PARTNERSHIP = 'CIVIL_PARTNERSHIP',
  SEPARATED = 'SEPARATED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED',
}

export const nationalitiesWithBritainAtStartAndOnlyOnce = countries
  .filter(val => val.value !== 'British')
  .map(val =>
    val.value === 'AAABritish'
      ? {
          value: 'British',
          label: 'British',
        }
      : val,
  );
